import React, { useEffect, useState } from "react";

/**
 * Editable current-page control for list pagination.
 * Disabled when totalPages <= 1. Rejects / clamps values above totalPages.
 */
export default function PageNumberInput({
  page,
  totalPages,
  onPageChange,
  disabled = false,
  className = "h-[35px] w-12 rounded border border-gray-300 text-center text-sm font-UbuntuMedium shadow-sm outline-none disabled:cursor-not-allowed disabled:bg-gray-100 disabled:opacity-70",
  style,
}) {
  const maxPages = Math.max(1, Number(totalPages) || 1);
  const current = Math.min(Math.max(1, Number(page) || 1), maxPages);
  const isDisabled = Boolean(disabled) || maxPages <= 1;
  const [draft, setDraft] = useState(String(current));

  useEffect(() => {
    setDraft(String(current));
  }, [current]);

  const commit = (raw) => {
    const digits = String(raw ?? "").replace(/\D/g, "");
    if (digits === "") {
      setDraft(String(current));
      return;
    }
    let n = Number(digits);
    if (!Number.isFinite(n) || n < 1) n = 1;
    if (n > maxPages) n = maxPages;
    setDraft(String(n));
    if (n !== current) onPageChange?.(n);
  };

  return (
    <input
      type="text"
      inputMode="numeric"
      pattern="[0-9]*"
      aria-label="Page number"
      value={draft}
      disabled={isDisabled}
      className={className}
      style={style}
      onChange={(e) => {
        const digits = e.target.value.replace(/\D/g, "");
        if (digits === "") {
          setDraft("");
          return;
        }
        const n = Number(digits);
        if (Number.isFinite(n) && n > maxPages) {
          setDraft(String(maxPages));
          return;
        }
        setDraft(digits);
      }}
      onBlur={() => commit(draft)}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          commit(draft);
          e.currentTarget.blur();
        }
      }}
    />
  );
}
